export default __webpack_public_path__ + "static/media/Amsterdam-Green.abfd2eb5.jpg";